module.exports = __webpack_public_path__ + "resources/img/logo_meetup.2cbfbc2dbb5a9d5331f68d76e6717d0e.png";